export const letterSpacing = {
  letterSpacing: {
    trackingTight: '0em',
    trackingNormal: '0.02em',
  },
};
